import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ro: {
    translation: require("./ro.json"),
  },
  en: {
    translation: require("./en.json"),
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ro",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
